import React from "react";
import { HubCard, SettingRow, Insight } from "../editHubPieces";
import { PRIVACY_ROWS } from "../editHubModel";

// v2 · 09 · Privacy
export const PrivacySection = ({ a, set }) => {
  const prefs = a.privacyPrefs || {};
  const toggle = (key) => (on) => set({ privacyPrefs: { ...prefs, [key]: on } });
  return (
    <>
      <HubCard title="What people can see" desc="Your data is yours. Change any of these anytime from your profile.">
        <div className="flex flex-col gap-3">
          {PRIVACY_ROWS.map((r) => (
            <SettingRow key={r.key} title={r.title} badge={r.badge} desc={r.desc} alwaysOn={!!r.forced} on={prefs[r.key] ?? r.defaultValue} onChange={toggle(r.key)} note={r.requiresAvatar && !a.avatar ? "Add a profile photo to appear in the index." : null} />
          ))}
        </div>
      </HubCard>
      <Insight>Hiding a number does not lower it. Brands still rank you on your CacheScore™. They just will not see your price until you share it.</Insight>
    </>
  );
};
